import React, { useState, useEffect } from "react";
import { Container, Card, Row, Col, Modal } from "react-bootstrap";
import "../../../asset/css/inbox.css";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import NoDataImage from "../../../asset/images/nodata.jpg";
import { BASE_URL } from "../CommonApi";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";
import Alert from "@mui/material/Alert";
import HRSEmployeeUpdate from "./HRSEmployeeUpdate";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeAccess from "./EmployeeAccess";
import EmployeeProfile from "./EmployeeProfile";

function EmployeeLeaveCard({ navigation }) {
  // const [employeeData, setEmployeeData] = useState([]);
  const [newItem, setnewItem] = useState([]);
  const [itemId, setItemID] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCard, setShowCard] = useState(true);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [showEmpAccess, setShowEmpAccess] = useState(false);
  const [showEmpProfile, setShowEmpProfile] = useState(false);

  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };
  const handleItemsClick = () => {
    handleNavigation("HRSEmployee");
  };

  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");

  const handleEdit = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(true);
    setShowEmpAccess(false);
    setShowEmpProfile(false);
  };

  const handleEmpAccessClick = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(false);
    setShowEmpAccess(true);
    setShowEmpProfile(false);
  };

  const handleEmpProfile = (id) => {
    setItemID(id);
    setShowCard(false);
    setShowUpdate(false);
    setShowEmpAccess(false);
    setShowEmpProfile(true);
  };

  // const handleDelete = (id) => {
  //   const userConfirmed = window.confirm(
  //     "Are you sure? Once deleted, you will not be able to recover this item!"
  //   );
  //   const jwtToken = localStorage.getItem("jwtToken");

  //   if (userConfirmed) {
  //     setLoading(true);
  //     // If the user clicks "OK", proceed with the deletion
  //     fetch(BASE_URL + `/deleteHrsDataById`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${jwtToken}`,
  //       },
  //       body: JSON.stringify({ id: String(id) }), // Ensure id is sent as a string
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.status === "200") {
  //           setLoading(false);
  //           // Remove the deleted item from the local state
  //           setEmployeeData((prevItems) =>
  //             prevItems.filter((employeeDatas) => employeeDatas.id !== id)
  //           );

  //           swal({
  //             icon: "success",
  //             title: "Item Deleted Successfully",
  //           });
  //           fetchEmployeeData();
  //         } else if (
  //           data.responseMessage ===
  //           "Items which are a part of other transactions cannot be deleted. Instead, mark them as inactive."
  //         ) {
  //           setLoading(false);
  //           window.confirm(
  //             "Items which are a part of other transactions cannot be deleted!"
  //           );
  //         } else {
  //           setLoading(false);
  //           console.error("Failed to delete Item");
  //         }
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.error("Error deleting Item:", error);
  //       });
  //   } else {
  //     setLoading(false);
  //     // If the user clicks "Cancel", do nothing
  //     alert("Item deletion canceled!");
  //   }
  // };

  const fetchEmployeeData = () => {
    // $("#DataTables_Table_0").DataTable();

    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const jwtToken = localStorage.getItem("jwtToken");

    const postApiUrl = BASE_URL + `/getHrsEmpDataByUniqueId`;

    setLoading(true);
    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Employee Data:", data);
        if (data.status === "success") {
          setLoading(false);
          setEmployeeData(data.data);
        } else {
          setLoading(false);
          console.error("Failed to fetch employees:", data.data);
        }
        // setLoading(false);
        // $("#DataTables_Table_0").DataTable();
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
        setLoading(false);
        // $("#DataTables_Table_0").DataTable();
      });
  };

  useEffect(() => {
    // fetchEmployeeData();
    // fetchAccessData();
  }, []);

  let i = 1;

  const handleItem = (name, id) => {
    setItemID(id);
    setnewItem(name);
    setShowDetails(true);
    setShowCard(false);
    setShowUpdate(false);
  };

  // Add this at the top of your component with other imports
  const dummyEmployeeLeaveData = [
    {
      id: 1,
      employeeId: "EMP001",
      employeeName: "John Doe",
      leaveDescription: "Annual leave for vacation",
      status: "Pending",
    },
    {
      id: 2,
      employeeId: "EMP002",
      employeeName: "Jane Smith",
      leaveDescription: "Sick leave due to flu",
      status: "Pending",
    },
    {
      id: 3,
      employeeId: "EMP003",
      employeeName: "Emily Johnson",
      leaveDescription: "Maternity leave",
      status: "Pending",
    },
    {
      id: 4,
      employeeId: "EMP004",
      employeeName: "Robert Davis",
      leaveDescription: "Personal leave for family event",
      status: "Pending",
    },
    {
      id: 5,
      employeeId: "EMP005",
      employeeName: "Michael Wilson",
      leaveDescription: "Medical leave for surgery recovery",
      status: "Pending",
    },
  ];

  // Then modify your useState initialization to use this dummy data
  const [employeeData, setEmployeeData] = useState(dummyEmployeeLeaveData);

  if (loading) {
    return (
      <div className="container-fluid ">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      {!showUpdate && !showDetails && !showEmpAccess && !showEmpProfile && (
        <div className="item-page">
          <div className="d-flex justify-content-between">
            <div
              className="mt-2"
              style={{
                color: "#3C7BD4",
                fontSize: 20,
                fontWeight: "600",
                wordWrap: "break-word",
                textAlign: "left",
              }}
            >
              Employee Leave Management
            </div>
            <div className="button-container d-flex">
              {/* <button
                className="btn btn-primary px-1 py-2 new-button"
                onClick={handleItemsClick}
              >
                + Employee
              </button> */}
            </div>
          </div>
        </div>
      )}
      {showCard && (
        <div
          className="container-fluid"
          style={{ border: "none", borderRadius: "7px" }}
        >
          <div className="page-content ">
            <Container fluid={true} className="">
              <Row>
                <Col>
                  <Card style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    {employeeData && employeeData.length > 0 ? (
                      <>
                        <div className="body">
                          <div className="table-responsive1">
                            <div
                              id="DataTables_Table_0_wrapper"
                              className="dataTables_wrapper dt-bootstrap4 no-footer"
                            >
                              <div className="row">
                                <div className="col-sm-12">
                                  <table
                                    className="table table-hover js-basic-example dataTable table-custom mb-0 no-footer"
                                    id="DataTables_Table_0"
                                    role="grid"
                                    aria-describedby="DataTables_Table_0_info"
                                  >
                                    <thead className="heading-text">
                                      <tr role="row">
                                        <th
                                          className="sorting_asc"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-sort="ascending"
                                          aria-label="Date: activate to sort column descending"
                                        >
                                          Serial no.
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="Type: activate to sort column ascending"
                                        >
                                          Employee Id
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="Amount BTC: activate to sort column ascending"
                                        >
                                          Employee Name
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="BTC Remaining: activate to sort column ascending"
                                        >
                                          Leave Description
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="BTC Remaining: activate to sort column ascending"
                                        >
                                          Status
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex="0"
                                          aria-controls="DataTables_Table_0"
                                          rowSpan="1"
                                          colSpan="1"
                                          aria-label="Price: activate to sort column ascending"
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="text1">
                                      {employeeData.map((data, index) => (
                                        <tr
                                          role="row"
                                          className="odd"
                                          key={data.id}
                                        >
                                          <td>{index + 1}</td>
                                          <td className="sorting_1">
                                            <a href="#">{data.employeeId}</a>
                                          </td>
                                          <td>{data.employeeName}</td>
                                          <td>{data.leaveDescription}</td>
                                          <td>{data.status}</td>
                                          <td>
                                            <button
                                              className="btn btn-success px-1 py-2 new-button mr-2"
                                              onClick={() => {
                                                // Update status to approved
                                                const updatedData =
                                                  employeeData.map((item) =>
                                                    item.id === data.id
                                                      ? {
                                                          ...item,
                                                          status: "Approved",
                                                        }
                                                      : item
                                                  );
                                                setEmployeeData(updatedData);
                                              }}
                                            >
                                              Approved
                                            </button>
                                            <button
                                              className="btn btn-danger px-1 py-2 new-button"
                                              onClick={() => {
                                                // Update status to rejected
                                                const updatedData =
                                                  employeeData.map((item) =>
                                                    item.id === data.id
                                                      ? {
                                                          ...item,
                                                          status: "Rejected",
                                                        }
                                                      : item
                                                  );
                                                setEmployeeData(updatedData);
                                              }}
                                            >
                                              Rejected
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="body">
                        <div className="table-responsive1">
                          <div
                            id="DataTables_Table_0_wrapper"
                            className="dataTables_wrapper dt-bootstrap4 no-footer"
                          >
                            <div className="row">
                              <div className="col-sm-12">
                                <table
                                  className="table table-hover js-basic-example dataTable table-custom mb-0 no-footer"
                                  id="DataTables_Table_0"
                                  role="grid"
                                  aria-describedby="DataTables_Table_0_info"
                                >
                                  <thead className="heading-text">
                                    <tr role="row">
                                      <th
                                        className="sorting_asc"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-sort="ascending"
                                        aria-label="Date: activate to sort column descending"
                                      >
                                        Serial no.
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="Type: activate to sort column ascending"
                                      >
                                        Employee Id
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="Amount BTC: activate to sort column ascending"
                                      >
                                        Employee Name
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="BTC Remaining: activate to sort column ascending"
                                      >
                                        Leave Description
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="BTC Remaining: activate to sort column ascending"
                                      >
                                        Status
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex="0"
                                        aria-controls="DataTables_Table_0"
                                        rowSpan="1"
                                        colSpan="1"
                                        aria-label="Price: activate to sort column ascending"
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody></tbody>
                                </table>
                                <h6 className="text-center">
                                  <img
                                    src={NoDataImage}
                                    style={{ width: "50%", height: "50%" }}
                                    alt="No Data Logo"
                                  />{" "}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeeLeaveCard;
